
import { createRouter, createWebHistory } from 'vue-router'
import LicenceView from '../views/LicenceView.vue';
import UserView from '../views/UserView.vue';
import SigninView from '../views/SigninView.vue';
import authService from '../services/authService';
import redirectService from '../services/redirectService';
import eventDispatcher from '../eventDispatcher';
import eventConfig from '@/configs/eventConfig';

const defaultMeta = {
};

const requireAuthMeta = {
  requiresAuth: true
};

const routes = [
  {
    path: '/licence',
    name: 'Licence',
    component: LicenceView,
    meta: requireAuthMeta
  },
  {
    path: '/user/:id/:module',
    name: 'User',
    component: UserView,
    meta: requireAuthMeta
  },
  {
    path: '/signin',
    name: 'Signin', 
    meta: defaultMeta,
    component: SigninView
  },
  {
    path: '/',
    redirect: to => {
      return 'licence'
    }
  }
];


var router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    
    authService.isUserAuth().then(
      response => {
        next();
      },
      error => {
        redirectService.setRedirectRoute(to);
        
        next({ name: 'Signin' });
      }
    );

  }else{
    
        next();
    
  }


});

eventDispatcher.on(eventConfig.UNAUTHORIZED, () => {
  router.push({ name: 'Signin' });
})

export default router
